import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-channel",
  "use": "icon-channel-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-channel\"><path d=\"M740-40v-120H620v-60h120v-120h60v120h120v60H800v120h-60Zm0-399v-361h60v361h-60ZM160-160v-640h60v640h-60Zm290-493v-147h60v147h-60Zm0 246v-147h60v147h-60Zm0 247v-148h60v148h-60Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol